import Vue from 'vue'
import Router from 'vue-router'
// import { store } from '../store'

//
import Index from '../components/index'
//
const Accueil = resolve => {
  require.ensure(['../components/accueil/index'], () => {
    resolve(require('../components/accueil/index'));
  });
};
//
const Apropos = resolve => {
  require.ensure(['../components/apropos/index'], () => {
    resolve(require('../components/apropos/index'));
  });
};
//
const Blog = resolve => {
  require.ensure(['../components/blog/index'], () => {
    resolve(require('../components/blog/index'));
  });
};
//
const Connection = resolve => {
  require.ensure(['../components/connection/index'], () => {
    resolve(require('../components/connection/index'));
  });
};
//
const Contact = resolve => {
  require.ensure(['../components/contact/index'], () => {
    resolve(require('../components/contact/index'));
  });
};
//
const Details_Article = resolve => {
  require.ensure(['../components/details_article/index'], () => {
    resolve(require('../components/details_article/index'));
  });
};
//
const Details_Entreprise = resolve => {
  require.ensure(['../components/details_entreprise/index'], () => {
    resolve(require('../components/details_entreprise/index'));
  });
};
//
const Entreprises = resolve => {
  require.ensure(['../components/entreprises/index'], () => {
    resolve(require('../components/entreprises/index'));
  });
};
//
const Erreur_404 = resolve => {
  require.ensure(['../components/erreur_404/index'], () => {
    resolve(require('../components/erreur_404/index'));
  });
};
//
const Offres = resolve => {
  require.ensure(['../components/offres/index'], () => {
    resolve(require('../components/offres/index'));
  });
};
//
const Partenariat = resolve => {
  require.ensure(['../components/partenariat/index'], () => {
    resolve(require('../components/partenariat/index'));
  });
};
//
const Profile = resolve => {
  require.ensure(['../components/profile/index'], () => {
    resolve(require('../components/profile/index'));
  });
};
//
const Reservation = resolve => {
  require.ensure(['../components/reservation/index'], () => {
    resolve(require('../components/reservation/index'));
  });
};
//
const Services_Entrprise = resolve => {
  require.ensure(['../components/services_entrprise/index'], () => {
    resolve(require('../components/services_entrprise/index'));
  });
};


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index ,
    },
    { path: '*', redirect: '/404' },
    {
      path: '/accueil',
      name: 'Accueil',
      component: Accueil ,
    },
    {
      path: '/apropos',
      name: 'Apropos',
      component: Apropos
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/connection',
      name: 'Connection',
      component: Connection
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/details-article',
      name: 'Details_Article',
      component: Details_Article
    },
    {
      path: '/details-entreprise',
      name: 'Details_Entreprise',
      component: Details_Entreprise
    },
    {
      path: '/entreprises',
      name: 'Entreprises',
      component: Entreprises
    },
    {
      path: '/404',
      name: 'Erreur_404',
      component: Erreur_404
    },
    {
      path: '/offres',
      name: 'Offres',
      component: Offres
    },
    {
      path: '/partenariat',
      name: 'Partenariat',
      component: Partenariat
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/reservation',
      name: 'Reservation',
      component: Reservation
    },
    {
      path: '/services-entrprise',
      name: 'Services_Entrprise',
      component: Services_Entrprise
    },
  ],
  mode: 'history',
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.configure({ easing: 'ease', speed: 700 });
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
  window.scrollTo(0,0);
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js